const CONVERSION_FACTORS: Record<number, number> = {
  0: 1,
  2: 100,
  3: 1000
};

export function parseBalanceAmount(
  amount: number | string | undefined = 0,
  currency?: string,
  asNumber?: true | false | undefined
) {
  const parsedAmount = Number(amount);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency ?? 'EUR'
  });
  const { maximumFractionDigits = 0 } = formatter.resolvedOptions();

  if (asNumber) {
    return parsedAmount / CONVERSION_FACTORS[maximumFractionDigits];
  }

  return (parsedAmount / CONVERSION_FACTORS[maximumFractionDigits]).toFixed(maximumFractionDigits);
}
